import * as React from 'react';
import { Button } from 'react-bootstrap';
import { flow } from 'lodash';
import { Field, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FaCheck } from 'react-icons/fa';
import FieldFormControl from '../FieldFormControl';
import { IStore } from '../../redux/IStore';
import { IMtaActions, IMtaFormNames, IMtaState } from '../../services/mta/models';
import { IUpsellCampaign } from '../../services/modal/model';
import { mtaActions } from '../../services/mta/actions';

interface IVoucherCodeProps {
  mta: IMtaState;
  campaign?: IUpsellCampaign;
  campaignCode: string;
  dispatch: any;
  change: any;
  discountCodeText?: string
  actions: {
    mta: IMtaActions
  };
}

class MTAVoucherCode extends React.Component<IVoucherCodeProps> {

  private checkVoucherCode = () => {
    const { actions, campaignCode } = this.props;
    actions.mta.checkVoucherCode(campaignCode)
  }

  private renderButtonMessage = () => {
    const { mta } = this.props;

    if (mta.voucherCodeStatus === 'success' && mta.regexVoucherCode) {
      return <span>Discount applied <FaCheck/></span>;
    }

    if (mta.voucherCodeStatus === 'success') {
      return <span>{mta.voucherCodeMessage} <FaCheck/></span>;
    }

    if (mta.voucherCodeStatus === 'error') {
      return <span>{mta.voucherCodeMessage} </span>;
    }

    return <span>ADD</span>;
  }

  public render() {
    const { mta, campaign, discountCodeText } = this.props;

    return (
      <div style={{ maxWidth: '1000px', textAlign: 'center', marginLeft: 'auto', marginRight: 'auto' }}>
        <div className="voucher-code-container">
          <div className={'voucher-code-input-box'}>
            <div className={'voucher-code-text'}>Got a discount
              code? {campaign?.code ? `(${campaign?.code})` : ''}</div>
            <div className={'voucher-code-input-body'}>
              <div className={mta.voucherCodeStatus === 'error' && 'has-error'}>
                <Field
                  name="data.attributes.metadata.campaign_code"
                  className="voucher-code-input"
                  placeholder={'Enter here...'}
                  component={FieldFormControl}
                  disabled={null !== mta.campaignCode || mta.voucherCodeStatus === 'success'}
                  type={mta.voucherCodePreventDisplay ? 'password' : 'text'}
                />
              </div>
            </div>
            <div className={'voucher-code-input-button'}>
              <Button
                bsStyle={mta.voucherCodeStatus === 'error' ? 'danger' : 'primary'}
                block={true}
                onClick={this.checkVoucherCode}
                className={(mta.voucherCodeStatus === 'error' || mta.voucherCodeStatus === 'success') ? '' : 'secondary-button'}
                disabled={null !== mta.campaignCode || mta.voucherCodeStatus === 'success'}
              >
                {this.renderButtonMessage()}
              </Button>
            </div>
          </div>
          {discountCodeText && <div className={'discount-code-description'}>{discountCodeText}</div>}
        </div>
      </div>
    );
  }
}

let selector;

export default flow([
  (component) => {
    selector = formValueSelector(IMtaFormNames.COVER_DETAILS);

    return component;
  },
  connect(
    (state: IStore) => {
      const campaignCode = selector(state, 'data.attributes.metadata.campaign_code') || null;
      return {
        mta: state.mta,
        campaignCode,
      };
    },
    (dispatch) => ({
      actions: {
        mta: bindActionCreators({ ...mtaActions }, dispatch),
      },
    }),
  ),
])(MTAVoucherCode);
